<template>
    <div class="te-event-price-list">
        <div class="te-event" v-if="event">
            <span class="te-event__title">{{event.name}}</span>
            <span class="te-event__date">{{eventDate}}</span>
            <span class="te-event__location">{{event.location}}</span>
        </div>

        <order-messages></order-messages>

        <coupon :order="order" :language="languageSettings"></coupon>

        <time-slot-selector v-if="showTimeSlotSelector" :language="language" @select="onSelectTimeSlot"></time-slot-selector>
        <price-list v-if="showPriceList" :prices="eventPriceList" :language="language" @add="onAddToCart"></price-list>

<!--        <div v-if="!availablePrices">{{languageSettings.noPrices}}</div>-->
<!--        <div v-if="availablePrices && !availableCapacity">{{languageSettings.noCapacity}}</div>-->
        <div v-if="message">{{message}}</div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import moment from "moment";
    import PriceList from './PriceList';
    import Coupon from './Coupon';
    import OrderMessages from './OrderMessages';
    import TimeSlotSelector from './TimeSlotSelector';
    import 'moment/locale/nl';

    export default {
        name: "EventPriceList",

        components: {
            PriceList,
            Coupon,
            OrderMessages,
            TimeSlotSelector,
        },

        data() {
            return {
                capacityLocationPath: null,
            };
        },

        props: {
            salesChannelId: {
                type: String,
                required: true
            },
            registerId: {
                type: String,
                required: true
            },
            eventId: {
                type: String,
                required: true
            },
            orderId: {
                type: String
            },
            customerId: {
                type: String
            },
            preferredLanguageCode: {
                type: String
            },
            language: {
                type: Object
            },
            defaultQuantity: {
                type: Number,
                default: 0
            },
            // isLoading: {
            //     type: Boolean,
            //     default: false
            // },
        },

        computed: {
            ...mapGetters({
                error: 'error',
                jobs: 'jobs',
                event: 'event',
                locale: 'locale',
                order: 'order',
                orderIdFromState: 'orderId',
                priceList: 'eventPriceList'
            }),

            eventPriceList: function() {
                const availableCapacity = this.event.availableCapacity;
                const getLimit = this.getLimit;
                let quantity = this.defaultQuantity;
                if(quantity === 0 && this.priceList.length === 1) quantity = 1;
                return !this.priceList ? [] : this.priceList.map(p => {
                    return {
                        conditionId: p.conditionId,
                        type: "access",
                        amount: p.price,
                        currency: p.currency,
                        tax: p.tax,
                        description: p.description,
                        // quantity: 0,
                        quantity: quantity,
                        limit: getLimit(p.limit, availableCapacity),
                        conditionPath: p.conditionPath,
                        accessDefinitionId: p.accessDefinition.id,
                        // eventManagerId: this.event ? this.event.eventManagerId : null,
                        // eventId: this.event ? this.event.eventId : null,
                    }
                });
            },

            availablePrices: function() {
                return this.priceList && this.priceList.length > 0;
            },

            availableCapacity: function() {
                // return this.event && this.event.availableCapacity && this.event.availableCapacity > 0;
                if(this.event && this.event.availableCapacity) {
                    if(this.event.availableCapacity > 0) {
                        return true;
                    }
                }
                return false
            },

            message: function() {
                if(!this.availableCapacity) return this.languageSettings.noCapacity;
                if(!this.availablePrices) return this.languageSettings.noPrices;
                return null;
            },

            eventDate: function() {
                return this.event ? moment(this.event.start).locale(this.locale).format('ddd D MMM HH:mm') + ' - ' + moment(this.event.end).locale(this.locale).format('HH:mm') : '';
            },

            canAddToken: function() {
                // return !this.order || (this.order && this.order.tokens === null)
                return true
            },

            isTimeSlotEvent: function () {
                if(this.event && this.event.hasTimeslots === true) {
                    return true;
                }
                return false;
            },

            showPriceList: function () {
                return this.availablePrices && this.availableCapacity && (!this.isTimeSlotEvent || (this.isTimeSlotEvent && this.capacityLocationPath !== null));
            },

            showTimeSlotSelector: function () {
                return this.isTimeSlotEvent && this.capacityLocationPath === null
            },


            languageSettings: function() {
                const defaultSettings = {
                    noPrices: 'No prices found.',
                    noCapacity: 'Sold out.',
                    free: 'Free',
                };
                return Object.assign(defaultSettings, this.language);
            },
        },

        methods: {
            ...mapActions([
                "getEventPriceList",
                "getEvent",
                "getOrder",
                "getOrderMessages",
                "addItemsToCart",
                // "addOrderToken"
            ]),

            onSelectTimeSlot(capacityLocationPath) {
                this.capacityLocationPath = capacityLocationPath;
                this.loadPricesList();
            },

            onAddToCart(eventPriceList) {
                const items = this.getAddItems(eventPriceList);
                this.addItemsToCart({items});
                this.$emit('add', items);
            },

            getAddItems(eventPriceList) {
                const cartItems = [];
                eventPriceList.forEach(p => {
                    for (let i = 0; i < p.quantity; i++) {
                        cartItems.push({
                            aggregateId: this.orderIdFromState,
                            eventManagerId: this.event.eventManagerId,
                            eventId: this.event.id,
                            accessDefinitionId: p.accessDefinitionId,
                            requestedConditionPath: p.conditionPath,
                            capacityLocationPath: this.capacityLocationPath,
                        })
                    }
                });
                return cartItems;
            },

            getLimit(limit, availableCapacity) {
                // if(!limit && availableCapacity) return availableCapacity;
                // if(limit && !availableCapacity) return limit;
                // if(limit < availableCapacity) return limit;
                // return availableCapacity;
                return (limit && availableCapacity && limit <= availableCapacity) ? limit : availableCapacity;
            },

            loadPricesList() {
                this.getEventPriceList({eventId: this.eventId, customerId: this.customerId, salesChannelId: this.salesChannelId, preferredLanguageCode: this.preferredLanguageCode, capacityLocationPath: this.capacityLocationPath});
            },

            async loadData() {
                const orderId = this.orderId ? this.orderId : this.orderIdFromState ? this.orderIdFromState : null;

                // get price list
                // await this.loadPricesList();
                await this.getEventPriceList({eventId: this.eventId, customerId: this.customerId, salesChannelId: this.salesChannelId, preferredLanguageCode: this.preferredLanguageCode, capacityLocationPath: this.capacityLocationPath});

                // get event
                if(this.eventId) {
                    this.getEvent({eventId: this.eventId});
                }

                // get order
                if(orderId) {
                    this.getOrder({orderId: orderId, forceReload: true});
                }

                // get order messages
                this.getOrderMessages({stage: 'PriceList', orderId, eventId: this.eventId, customerId: this.customerId, salesChannelId: this.salesChannelId, preferredLanguage: this.preferredLanguageCode});
            },

        },

        created() {
            this.loadData();
            // const orderId = this.orderId ? this.orderId : this.orderIdFromState ? this.orderIdFromState : null;
            //
            // // get price list
            // this.loadPricesList();
            //
            // // get event
            // if(this.eventId) {
            //     this.getEvent({eventId: this.eventId});
            // }
            //
            // // get order
            // if(orderId) {
            //     this.getOrder({orderId: orderId, forceReload: true});
            // }
            //
            // // get order messages
            // this.getOrderMessages({stage: 'PriceList', orderId, eventId: this.eventId, customerId: this.customerId, salesChannelId: this.salesChannelId, preferredLanguage: this.preferredLanguageCode});
        }
    }
</script>

<style scoped>

</style>
